import { ISublistDto } from "../../interface/dto/sublist.dto";
import { SublistActionType, ISublistAction } from "./sublists.actions";

export interface ISublistState {
    isLoading: boolean;
    error?: string;
    data?: Array<ISublistDto>;
}

const initState: ISublistState = {
    isLoading: false,
    data: undefined,
};

export const sublistReducer = (state = initState, action: ISublistAction) => {
    switch (action.type) {
        case SublistActionType.SUBLIST_GET:
            return {
                ...state,
                isLoading: true,
                error: undefined,
                data: undefined,
            };
        case SublistActionType.SUBLIST_GET_ERROR:
            return { ...state, error: action.payload.error, isLoading: false };
        case SublistActionType.SUBLIST_GET_SUCCESS:
            return {
                ...state,
                data: action.payload.sublist?.sort(
                    (a, b) => b.records - a.records,
                ),
                isLoading: false,
            };
        default:
            return state;
    }
};
